import { render, staticRenderFns } from "./joinForm.vue?vue&type=template&id=4d96296a&scoped=true"
import script from "./joinForm.vue?vue&type=script&lang=js"
export * from "./joinForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d96296a",
  null
  
)

export default component.exports